import { useTranslation } from "react-i18next";
import { weekIn } from "../../../../lib/utils";
import defaultImg from '/src/assets/images/default-image-library.png';


export const Lession = ({ course, index }: { course: any; index: number }) => {
  const { t } = useTranslation();
  const weekDetail = weekIn(index);

  return (
    <>
      <div className="flex-none relative rounded-lg border mr-5 bg-fillMidGrayCard hover:opacity-100 hover:bg-black sm:w-[80px] sm:h-[54px] lg:w-[110px] lg:h-[72px] overflow-hidden max-sm:w-[110px] max-sm:h-[72px]">
      {course?.coverUrl  ? 
        <img
          src={course?.coverUrl ? course?.coverUrl : weekDetail.image}
          alt={t("CourseDetails.fallbackText").replace(/<\/?[^>]+(>|$)/g, "")}
          className="w-full h-[inherit] object-cover bg-center lg:col-span-full"
        />:(
          <img
            src={defaultImg}
            alt={" "}
            className="rounded-t-lg w-full h-full aspect-[3/2] object-cover"
          />
        )}
      </div>
      <div className="flex flex-col w-full">
        <p className="font-opensansSemiBold lg:text-base xl:text-lg">
        <span dangerouslySetInnerHTML={{ __html: (t("Program.lesson")) }} />{" "} {index + 1}
        <p>{course?.name}</p> 
        </p>
      </div>
    </>
  );
};
